import { ManagerRoles, TaskFilterPermissions, UserRole } from '../../types';

// jira: AP-359
export const taskListFilters: TaskFilterPermissions = {
  quickFilterDueToday: [...ManagerRoles, UserRole.SVCUSR_SPR],
  quickFilterBreach: [...ManagerRoles, UserRole.SVCUSR_SPR],
  quickFilterWarning: [...ManagerRoles, UserRole.SVCUSR_SPR],
  linkedAsset: [...ManagerRoles, UserRole.SVCUSR_SPR, UserRole.SVCUSR, UserRole.SUPP, UserRole.SUPP_SPR],
  assignedUser: ManagerRoles,
  assignedTeam: ManagerRoles,
  created: [...ManagerRoles, UserRole.SVCUSR_SPR],
  due: [...ManagerRoles, UserRole.SVCUSR_SPR],
  statusType: [...ManagerRoles, UserRole.SVCUSR_SPR, UserRole.SVCUSR, UserRole.SUPP, UserRole.SUPP_SPR],
  priority: [...ManagerRoles, UserRole.SVCUSR_SPR],
  slaStatus: [...ManagerRoles, UserRole.SVCUSR_SPR],
  status: [...ManagerRoles, UserRole.SVCUSR_SPR, UserRole.SVCUSR, UserRole.SUPP, UserRole.SUPP_SPR],
  taskType: [...ManagerRoles, UserRole.SVCUSR_SPR],
};

// jira: AP-1282
export const teamLinkedTasksFilters: TaskFilterPermissions = {
  quickFilterDueToday: ManagerRoles,
  quickFilterBreach: ManagerRoles,
  quickFilterWarning: ManagerRoles,
  linkedAsset: ManagerRoles,
  assignedUser: ManagerRoles,
  assignedTeam: [],
  created: ManagerRoles,
  due: ManagerRoles,
  statusType: ManagerRoles,
  priority: ManagerRoles,
  slaStatus: ManagerRoles,
  status: ManagerRoles,
  taskType: ManagerRoles,
};

// jira: AP-1282
export const orgLinkedTasksFilters: TaskFilterPermissions = {
  quickFilterDueToday: [...ManagerRoles, UserRole.SVCUSR_SPR],
  quickFilterBreach: [...ManagerRoles, UserRole.SVCUSR_SPR],
  quickFilterWarning: [...ManagerRoles, UserRole.SVCUSR_SPR],
  linkedAsset: [...ManagerRoles, UserRole.SVCUSR_SPR, UserRole.SUPP_SPR],
  assignedUser: ManagerRoles,
  assignedTeam: ManagerRoles,
  created: [...ManagerRoles, UserRole.SVCUSR_SPR],
  due: [...ManagerRoles, UserRole.SVCUSR_SPR],
  statusType: [...ManagerRoles, UserRole.SVCUSR_SPR, UserRole.SUPP_SPR],
  priority: [...ManagerRoles, UserRole.SVCUSR_SPR],
  slaStatus: [...ManagerRoles, UserRole.SVCUSR_SPR],
  status: [...ManagerRoles, UserRole.SVCUSR_SPR, UserRole.SUPP_SPR],
  taskType: [...ManagerRoles, UserRole.SVCUSR_SPR],
};

// jira: AP-1282 - currently exactly the same as org
export const userLinkedTasksFilters = orgLinkedTasksFilters;

// jira: AP-1282
export const assetLinkedTasksFilters: TaskFilterPermissions = {
  quickFilterDueToday: [...ManagerRoles, UserRole.SVCUSR_SPR],
  quickFilterBreach: [...ManagerRoles, UserRole.SVCUSR_SPR],
  quickFilterWarning: [...ManagerRoles, UserRole.SVCUSR_SPR],
  linkedAsset: [],
  assignedUser: ManagerRoles,
  assignedTeam: ManagerRoles,
  created: [...ManagerRoles, UserRole.SVCUSR_SPR],
  due: [...ManagerRoles, UserRole.SVCUSR_SPR],
  statusType: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SUPP, UserRole.SVCUSR, UserRole.SVCUSR_SPR],
  priority: [...ManagerRoles, UserRole.SVCUSR_SPR],
  slaStatus: [...ManagerRoles, UserRole.SVCUSR_SPR],
  status: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SUPP, UserRole.SVCUSR, UserRole.SVCUSR_SPR],
  taskType: [...ManagerRoles, UserRole.SVCUSR_SPR],
};
